/**
 * Ger föräldraelementet till .parent-sticky-top klassen sticky-top. Markupen kan
 * inte sätta den direkt eftersom sticky måste sitta på en förälder som inte har
 * overflow-begränsning.
 *
 * Ersätter FrontendSrc/patternlab/js/parent-sticky-top.js.
 */
export function initParentStickyTop(): void {
    document.querySelectorAll<HTMLElement>('.parent-sticky-top').forEach(el => {
        // Originalet anvande jQuerys .parent('div') och satte alltsa klassen
        // bara nar den direkta foraldern var en <div>. Filtret behalls: sticky
        // pa ett annat element ar inte nodvandigtvis meningsfullt, och en
        // tystnande beteendeandring for framtida block vore svar att spara.
        const parent = el.parentElement;
        if (parent instanceof HTMLDivElement) parent.classList.add('sticky-top');
    });
}
